import React from "react"


const Suppen = () => {
    return(
       <div>
           <h1 className="center" >Suppen</h1>
           
       </div>
    )
}

export default Suppen